import { lazy } from 'react'

export const privateRoutes = [
  { path: '/', component: lazy(() => import('../pages/Home/Home')), required: [] },
  {
    path: '/users/:userId',
    component: lazy(() => import('../pages/users/details')),
    required: ['CORE_USERS_VIEW'],
  },
  {
    path: '/users',
    component: lazy(() => import('../pages/users')),
    required: ['CORE_USERS_VIEW'],
  },
  {
    path: '/users/create',
    component: lazy(() => import('../pages/users/create')),
    required: ['CORE_USRS_ADD'],
  },

  // Cards
  {
    path: '/cards',
    component: lazy(() => import('../pages/cards')),
    required: ['CORE_CARDS_VIEW'],
  },
  {
    path: '/cards/:id',
    component: lazy(() => import('../pages/cards/details')),
    required: ['CORE_CARDS_DETAILS_VIEW'],
  },
  {
    path: '/cards/transactions',
    component: lazy(() => import('../pages/cards/transactions')),
    required: ['CORE_CARDS_TRXS_VIEW'],
  },

  // Settings
  {
    path: '/settings/apps',
    component: lazy(() => import('../pages/settings/apps')),
    required: ['CORE_SETTINGS_APPS_MNU'],
  },
  {
    path: '/settings/roles',
    component: lazy(() => import('../pages/settings/roles')),
    required: ['CORE_SETTINGS_ROLES_MNU'],
  },
  {
    path: '/users_roles',
    component: lazy(() => import('../pages/settings/users-roles')),
    required: ['CORE_USR_ROLES'],
  },
  {
    path: '/settings/profiles',
    component: lazy(() => import('../pages/ProfilesManagement')),
    required: ['CORE_COMPLIANCE_PROFILES_MENU'],
  },
  {
    path: '/settings/alerts',
    component: lazy(() => import('../pages/alerts')),
    required: ['CORE_COMPLIANCE_ALERTS'],
  },
  {
    path: '/settings/alerts/:id',
    component: lazy(() => import('../pages/alerts/details')),
    required: ['CORE_COMPLIANCE_ALERT_UPD'],
  },
  {
    path: '/settings/scopes',
    component: lazy(() => import('../pages/settings/scopes')),
    required: ['SUPERADMIN'],
  },
  {
    path: '/settings/types',
    component: lazy(() => import('../pages/settings/elements-types')),
    required: ['CORE_ELEMTYPE_MNU'],
  },
  {
    path: '/settings/subtypes',
    component: lazy(() => import('../pages/settings/sub-elements-types')),
    required: ['CORE_ELEMSUBTYPE_MNU'],
  },
  {
    path: '/settings/functionalities',
    component: lazy(() => import('../pages/settings/functionalities')),
    required: ['CORE_FUNCT_MNU'],
  },
  {
    path: '/settings/functionalities/details/:id',
    component: lazy(() => import('../pages/settings/functionalities/details')),
    required: ['CORE_FUNC_UPD'],
  },
  {
    path: '/settings/functionalities/create',
    component: lazy(() => import('../pages/settings/functionalities/create')),
    required: ['CORE_FUNC_ADD'],
  },
  {
    path: '/settings/general',
    component: lazy(() => import('../pages/settings/general')),
    required: ['CORE_SETTINGS_GENERAL_VIEW'],
  },
  {
    path: '/settings/general/create',
    component: lazy(() => import('../pages/settings/general/create')),
    required: ['CORE_SETTINGS_GENERAL_ADD'],
  },
  {
    path: '/settings/general/details',
    component: lazy(() => import('../pages/settings/general/details')),
    required: ['CORE_SETTINGS_GENERAL_UPD'],
  },
  {
    path: '/settings/general/others/:id',
    component: lazy(() => import('../pages/settings/general/others/update')),
    required: ['CORE_SETTINGS_GENERAL_OTHERS_VIEW', 'CORE_SETTINGS_GENERAL_OTHERS_UPD'],
  },

  {
    path: '/settings/activities',
    component: lazy(() => import('../pages/settings/activities')),
    required: [],
  },
  {
    path: '/settings/collaborators',
    component: lazy(() => import('../pages/settings/collaborators')),
    required: ['CORE_SETTINGS_COLLABORATORS_MNU'],
  },
  {
    path: '/settings/collaborators/create',
    component: lazy(() => import('../pages/settings/collaborators/create')),
    required: ['CORE_SETTINGS_COLLABORATORS_ADD'],
  },
  {
    path: '/settings/collaborators/:userId',
    component: lazy(() => import('../pages/settings/collaborators/details')),
    required: ['CORE_SETTINGS_COLLABORATORS_VIEW'],
  },

  // Fees
  {
    path: '/fees/default',
    component: lazy(() => import('../pages/fees/default')),
    required: ['CORE_FEESES_DEFAULT_MNU'],
  },
  {
    path: '/fees/custom',
    component: lazy(() => import('../pages/fees/custom')),
    required: ['CORE_FEESES_CUSTOM_MNU'],
  },
  {
    path: '/fees/:id',
    component: lazy(() => import('../pages/fees/details')),
    required: ['CORE_FEESES_CUSTOM_UPD', 'CORE_FEESES_DIST_VIEW'],
  },
  {
    path: '/fees/register',
    component: lazy(() => import('../pages/fees/register')),
    required: ['CORE_FEESES_CUSTOM_ADD'],
  },

  // Compliance
  {
    path: '/verifications',
    component: lazy(() => import('../pages/compliance/verifications')),
    required: ['CORE_COMPLIANCE_VERIFICATIONS_MENU'],
  },
  {
    path: '/compliance/nosis/queries',
    component: lazy(() => import('../pages/compliance/nosis/queries')),
    required: ['CORE_COMPLIANCE_NOSIS_VIEW'],
  },
  {
    path: '/compliance/rules',
    component: lazy(() => import('../pages/compliance/rules')),
    required: ['CORE_COMPLIANCE_RULES_VIEW'],
  },
  {
    path: '/compliance/nosis/:id',
    component: lazy(() => import('../pages/compliance/nosis/queries/details')),
    required: ['CORE_COMPLIANCE_RULES_DETAILS_VIEW'],
  },

  // Checks
  {
    path: '/checks',
    component: lazy(() => import('../pages/checks')),
    required: ['CORE_CHECKS_MNU'],
  },
  {
    path: '/checks/:id',
    component: lazy(() => import('../pages/checks/details')),
    required: ['CORE_CHECKS_VIEW'],
  },

  // Requests
  {
    path: '/request',
    component: lazy(() => import('../pages/request')),
    required: [],
  },
  {
    path: '/request/:id',
    component: lazy(() => import('../pages/request/details')),
    required: [],
  },

  // Accounting
  {
    path: '/accounting/reconcile/redlink',
    component: lazy(() => import('../pages/RedLinkManagement')),
    required: ['CORE_ACCT_RECON_REDLINK_MENU'],
  },
  // Taxes
  {
    path: '/taxes/arg/ibba/master',
    component: lazy(() => import('../pages/taxes/master')),
    required: [],
  },
  {
    path: '/taxes/arg/ibba/groups',
    component: lazy(() => import('../pages/taxes/groups')),
    required: [],
  },

  // Transactions
  {
    path: '/transactions/:id',
    component: lazy(() => import('../pages/banking/cvu/transactions/details')),
    required: [],
  },

  // Banking - CVU
  {
    path: '/banking/cvu/list',
    component: lazy(() => import('../pages/banking/cvu/list')),
    required: ['CORE_BANKING_CVUS_MNU', 'CORE_CVU_LIST'],
  },
  {
    path: '/banking/cvu/details/:id',
    component: lazy(() => import('../pages/banking/cvu/details')),
    required: ['CORE_CVU_LIST'],
  },
  {
    path: '/banking/cvu/transactions',
    component: lazy(() => import('../pages/banking/cvu/transactions')),
    required: ['CORE_CVU_TRXS'],
  },
  {
    path: '/banking/cvu/notifications',
    component: lazy(() => import('../pages/banking/cvu/notifications')),
    required: ['CORE_CVU_NOTIF_MNU'],
  },
  {
    path: '/banking/cvu/notifications/:id',
    component: lazy(() => import('../pages/banking/cvu/notifications/details')),
    required: ['CORE_CVU_NOTIF_UPD'],
  },
  {
    path: '/banking/cvu/notifications/create',
    component: lazy(() => import('../pages/banking/cvu/notifications/create')),
    required: ['CORE_CVU_NOTIF_ADD'],
  },
  {
    path: '/banking/cvu/create',
    component: lazy(() => import('../pages/banking/cvu/create')),
    required: ['CORE_CVU_CREATE'],
  },
  {
    path: '/banking/cvu/blacklist',
    component: lazy(() => import('../pages/banking/cvu/blacklist')),
    required: ['CORE_CVU_BLACK_MENU'],
  },

  // Banking - ACH
  {
    path: '/banking/ach/transactions',
    component: lazy(() => import('../pages/banking/ach/transactions')),
    required: ['CORE_CVU_ACH_TRXS_MNU'],
  },
  {
    path: '/banking/ach/provisioning',
    component: lazy(() => import('../pages/banking/ach/provisioning')),
    required: ['CORE_ACH_PROV_MNU'],
  },

  // Banking - Banks
  {
    path: '/banking/banks',
    component: lazy(() => import('../pages/banking/banks/list')),
    required: ['CORE_BANKS_VIEW'],
  },
  {
    path: '/banking/banks/:id',
    component: lazy(() => import('../pages/banking/banks/details')),
    required: ['CORE_BANKS_UPD'],
  },

  // Forbidden
  { path: '/forbidden', component: lazy(() => import('../pages/forbidden')), required: [] },
]
